<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-等级管理-添加等级
  -->
  <el-dialog
    title="添加等级"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
  >
    <el-form size="small" :model="form" ref="form">
      <el-form-item
        label="等级名称"
        :label-width="formLabelWidth"
        prop="name"
        :rules="[{ required: true, message: '请输入等级名称' }]"
      >
        <el-input v-model="form.name" placeholder="请输入等级名称"></el-input>
      </el-form-item>

      <el-form-item label="等级" :label-width="formLabelWidth">
        <el-input type="number" name="" id="" />
        <div>级别数字越大表示等级越高，等级级别不能相同。填写大于1的整数</div>
      </el-form-item>
      <el-form-item label="佣金" :label-width="formLabelWidth">
        <el-input type="number" name="" id="" />
        <div>等级佣金总和不能超过100%</div>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addGrade()" :disabled="submit_loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import UserApi from "@/api/user.js";
export default {
  data() {
    return {
      form: {
        /*昵称*/
        name: "",
        /*等级折扣*/
        equity: "",
        /*是否打开累计消费满*/
        open_money: 0,
        /*累计消费满*/
        upgrade_money: 0,
        /*是否打开累计积分满*/
        open_points: 0,
        /*累计积分满*/
        upgrade_points: 0,
        /*是否推荐人数满*/
        open_invite: 0,
        /*推荐人数满*/
        upgrade_invite: 0,
        /*等级权重*/
        weight: 100
      },
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      /*是否正在提交*/
      submit_loading: false
    };
  },
  props: ["open_add"],
  created() {
    this.dialogVisible = this.open_add;
  },
  methods: {
    /*添加等级*/
    addGrade() {
      let self = this;
      let params = this.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.submit_loading = true;
          params.open_money = params.open_money == true ? 1 : 0;
          params.open_points = params.open_points == true ? 1 : 0;
          params.open_invite = params.open_invite == true ? 1 : 0;
          UserApi.addgrade(params, true)
            .then(data => {
              self.submit_loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.submit_loading = false;
            });
        }
      });
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/promotion/user/grade/part/Add.vue